<template>
  <div class="infoTable02">
    <ul>
      <li><em>모델</em><span>{{userVehicle.model.type}}</span></li>
      <li><em>차대번호</em><span>{{userVehicle.num_id}}</span></li>
      <li>
        <em>멤버십명</em>
        <span>
          BMW ServiceCare+<br>
          {{userPkg.title}}
        </span>
      </li>
      <!-- <li><em>서비스 기간</em><span>{{subscTerms[0]}}<br>~ {{subscTerms[1]}}</span></li> -->
      <li><em>서비스 기간</em><span>{{subscTerms}}</span></li>
      <li class="line"><em>소비자가</em><span>{{costService | currency}}원</span></li>
      
      <li v-if="costPromo">
        <em>프로모션가</em>
        <span v-if="paymentItem.promo_code.overlap==PROMO_TYPE_OVERLAP_DISABLE">VIP 할인코드 중복불가</span>
        <span class="fCol1" v-else>{{ (costService-costPromo) | currency}}원</span>
      </li>

      <li v-show="onSlug && !setPromoSlug">
        <em>VIP 코드</em>
        <!-- VIP 할인코드 미적용  -->
        <span v-if="!setPromoSlug">
          <!-- <a @click="onSlug=!onSlug" :class="[onSlug ? 'vipCollapse on' : 'vipCollapse']"></a> -->
        </span>
        <!--VIP 할인코드 적용된 경우 -->          
        <template v-else>
          <!-- <a class="btnS bLine" @click="unsetVipBenefits(false)">미적용</a> -->
          <!-- <span class="fCol2" v-if="paymentItem.promo_code.type_rate == PROMO_TYPE_RATE_RAFFLE">
            {{paymentItem.promo_code.title}}
          </span>
          <span class="fCol2" v-else>
            -{{paymentItem.promo_code.price | currency}}원
          </span> -->
          <span class="fCol2" v-if="paymentItem.promo_code.type_rate != PROMO_TYPE_RATE_RAFFLE">
            -{{paymentItem.promo_code.price | currency}}원
          </span>
        </template>
      </li>
      
      <!--VIP 할인코드 펼친 경우 할인코드 입력  -->
      <li class="line saleCode" v-show="onSlug && !setPromoSlug">
        <div :class="[slugCode ? 'wrapInp disabled' : 'wrapInp']">
          <input type="text" v-model="slugCode" id="changePhoneNum">
          <!-- <label for="changePhoneNum">VIP 할인코드 14자리 입력</label> -->
        </div>
        <button type="button" class="btnS" @click="setVipBenefits()" style="color:white;">적용</button>
      </li>
      
      <li class="line"><em>총 결제금액<br>(VAT포함)</em><span style="font-weight:bold;">{{costTotal | currency}}원</span></li>
    
      <li v-if="setPromoSlug && paymentItem.promo_code.type_rate == PROMO_TYPE_RATE_RAFFLE">
        <div v-html="paymentItem.promo_code.content.replace(/\n/gi, '<br>')"></div>
      </li>
    </ul>
  </div>
</template>


<script>
  import axios from 'axios';
  import {api} from '@/api';
  import Const from "@/helpers/Const";
  import { PromoMixin } from '@/mixins/PromoMixin';
  import Format from "../../helpers/Format";

  export default {
    mixins:[PromoMixin],
    components: {
    },

    computed: {
      PROMO_TYPE_RATE_RAFFLE() { return Const.PROMO_TYPE_RATE_RAFFLE; },

      costPromo() {
        let promoType = 'promo';
        if (this.$store.state.subsc.state_req == Const.SUBSC_STATE_REQ.ENABLE_EXT)
          promoType = 'promo_extend';
        let discount = 0;
        const pkgs = this.pkgs[this.userPkg.id];
        if (pkgs[promoType]) discount = this.setPromoRate(pkgs[promoType], this.costService);
        return discount;
      },
      subscTerms() {
        let term = this.getSubscPeriod();
        // let term = this.getSubscPeriod(this.$store.state.subsc.date_start);
        // term = term.split(' ~ ');
        return term;
      },
      costTotal() {
        let total = this.costService;
        //코드할인 없다.
        if (!this.paymentItem.promo_code.slug) total = total - this.costPromo;
        //코드할인 있지만 중복불가
        else if (this.paymentItem.promo_code.overlap != Const.PROMO.TYPE_OVERLAP.ENABLE)
          total = total - this.paymentItem.promo_code.price;
        //코드할인 있고 중복가능
        else total = total - this.costPromo - this.paymentItem.promo_code.price;
        if (total < 0) total = 0;
        return total;
      },
    },

    created() {
      this.emitPaymentItem();
    },

    data() {
      return {
        activate: false,
        activateMsg: '',
        onSlug: false,
        // onSlug: true,
        paymentItem: {
          payment: 0, //결제금액
          promo: {
            type: '',
            type_rate: '',
            price: 0, // 할인금액
            rate: 0, //할인율 or 금액
          },
          promo_code: {
            type: '',
            type_rate: '',
            title: '',
            content: '',
            overlap: 0, //중복여부
            price: 0, //할인금액
            rate: 0, //할인율 or 금액
            slug: '', //할인코드
          },
        },
        pkgs: this.$store.state.pkgs,
        PROMO_TYPE_OVERLAP_DISABLE: Const.PROMO.TYPE_OVERLAP.DISABLE,
        costService: this.$store.state.subsc.payments.price_pkg,
        setPromoSlug: false,
        slugCode: '',
        slugDiscount: 0,
        userPkg: this.$store.state.pkg,
        userVehicle: this.$store.state.vehicle,
        vehicles: this.$store.state.vehicleCats,
      }
    },

    filters: Format,

    methods: {
      emitPaymentItem() {
        this.paymentItem.payment = this.costTotal;
        if (this.pkgs[this.userPkg.id].promo) {
          this.paymentItem.promo.type = this.pkgs[this.userPkg.id].promo.type;
          this.paymentItem.promo.type_rate = this.pkgs[this.userPkg.id].promo.type_rate;
          this.paymentItem.promo.rate = this.pkgs[this.userPkg.id].promo.rate;
          this.paymentItem.promo.price = this.costPromo;
        }
        this.$emit('costCal', this.paymentItem);
      },

      setVipBenefits() {
        if (!this.slugCode) {
          const errorMsg = '할인코드를 입력해주세요.';
          this.$emit('wrongSlugCode', errorMsg);
          return;
        }
        const param = {pkg_id: this.userPkg.id};
        axios.get(`${api.promoLinks}/showBySlug/${this.slugCode}`, {params: param})
          .then(({data}) => {
            const promo_data = data.data.promo;
            this.paymentItem.promo_code.type = promo_data.type;
            this.paymentItem.promo_code.type_rate = promo_data.type_rate;
            this.paymentItem.promo_code.title = promo_data.title;
            this.paymentItem.promo_code.content = promo_data.content;
            this.paymentItem.promo_code.rate = promo_data.rate;
            this.paymentItem.promo_code.overlap = promo_data.type_overlap;
            this.paymentItem.promo_code.slug = this.slugCode;
            this.paymentItem.promo_code.price = this.setPromoRate(promo_data, this.costService);
            this.slugCode = '';
            this.setPromoSlug = true;
            this.emitPaymentItem();
          })
          .catch((error) => {
            const errCode = error.response.status;
            let errMsg = '';
            if (errCode == 409) {
              errMsg = error.response.data.data.msg;
            } else {
              errMsg = this.errorMsg(error);
            }
            this.slugCode = '';
            this.$emit('wrongSlugCode', errMsg);
          });
      },

      unsetVipBenefits() {
        // this.onSlug = false;
        this.setPromoSlug = false;
        this.paymentItem.promo_code.rate = 0;
        this.paymentItem.promo_code.overlap = 0;
        this.paymentItem.promo_code.slug = '';
        this.paymentItem.promo_code.price = 0;
        this.emitPaymentItem();
      },
    }
  }
</script>
